/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllPalAuthorizationsResponse } from './FindAllPalAuthorizationsResponse';
import {
    FindAllPalAuthorizationsResponseFromJSON,
    FindAllPalAuthorizationsResponseFromJSONTyped,
    FindAllPalAuthorizationsResponseToJSON,
} from './FindAllPalAuthorizationsResponse';

/**
 * 
 * @export
 * @interface FindAllPalAuthorizations200Response
 */
export interface FindAllPalAuthorizations200Response {
    /**
     * 
     * @type {FindAllPalAuthorizationsResponse}
     * @memberof FindAllPalAuthorizations200Response
     */
    data?: FindAllPalAuthorizationsResponse;
}

/**
 * Check if a given object implements the FindAllPalAuthorizations200Response interface.
 */
export function instanceOfFindAllPalAuthorizations200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPalAuthorizations200ResponseFromJSON(json: any): FindAllPalAuthorizations200Response {
    return FindAllPalAuthorizations200ResponseFromJSONTyped(json, false);
}

export function FindAllPalAuthorizations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalAuthorizations200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllPalAuthorizationsResponseFromJSON(json['data']),
    };
}

export function FindAllPalAuthorizations200ResponseToJSON(value?: FindAllPalAuthorizations200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllPalAuthorizationsResponseToJSON(value.data),
    };
}

